// ---------------------------------------------------------------------------
// About / Bio Section
// ---------------------------------------------------------------------------
// Each entry in the array becomes a paragraph in the bio section.
// HTML is supported (e.g. <br>, <strong>, <a>).

const about = [
  `I research power-constrained computing systems with an emphasis on co-design across materials,
hardware, and software. My work is grounded in the principle that transformational advances emerge
when the entire stack—from silicon and power electronics to system software and user interfaces—is
optimized for a specific application. My long-term focus is on translating advanced capabilities,
including hyperspectral imaging and semiconductor fabrication, into accessible platforms that enable
the next generation of engineers to be multidisciplinary from the outset.`,

  `I view people as an organization's most critical asset.
As the senior student in the VAK Embodied Systems Lab, I help manage, equip, and mentor an
interdisciplinary group of ~30 students spanning Electrical and Computer Engineering, Computer Science,
Mechanical Engineering, Environmental Engineering, Materials Science, Applied Mathematics, Physics, and Chemistry.
I emphasize team formation, technical integration, and mentorship as essential system components:
<br><br>
<strong>People are the pillar of full-spectrum engineering.</strong>`,
];

export default about;
